export default "__VITE_ASSET__Bym6Kwva__";